import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Edit, Trash2, Bell, Check } from "lucide-react";

const UpcomingReminders = ({
  reminders,
  onComplete,
  onEdit,
  onDelete
}) => {
  return (
    <Card className="border border-orange-200 bg-orange-50/30 shadow-sm rounded-sm" data-testid="upcoming-reminders">
      <CardHeader>
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Bell className="w-5 h-5 text-orange-500" />
          Prossimi Promemoria
        </CardTitle>
      </CardHeader>
      <CardContent>
        {reminders.length > 0 ? (
          <div className="divide-y divide-orange-200">
            {reminders.map(reminder => {
              const remDate = new Date(reminder.datetime_iso);
              return (
                <div key={reminder.reminder_id} className="py-3 flex justify-between items-center">
                  <div>
                    <p className="font-medium text-sm">{reminder.title}</p>
                    <p className="text-xs text-muted-foreground">
                      {remDate.toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" })}
                      {" alle "}
                      {remDate.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}
                      {reminder.is_recurring && <span className="ml-2">🔄</span>}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => onComplete(reminder.reminder_id)}
                      className="text-green-600 hover:text-green-700 transition-colors"
                      title="Completato"
                    >
                      <Check className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => onEdit(reminder)}
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      <Edit className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => onDelete(reminder.reminder_id)}
                      className="text-muted-foreground hover:text-destructive transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground text-center py-4">
            Nessun promemoria in programma
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default UpcomingReminders;
